<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      @delete="$emit('delete')"
      @duplicate="$emit('duplicate')"
      @page-break="$emit('page-break')"
      @hide="$emit('hide')"
    />
    <div :class="layoutClasses">
      <div
        v-if="label || description"
        class="formester-label-description-wrapper"
        :style="labelDescriptionWrapperStyles"
      >
        <label
          :class="labelClasses"
          :style="labelStyles"
          :for="item.label"
          v-html="label"
        >
        </label>
        <SmartText
          :active="active"
          :editing="editing"
          :item="item"
          :style="descriptionStyles"
          :text="description"
        />
      </div>

      <div class="embed-wrapper">
        <!-- eslint-disable vue/no-v-html -->
        <div v-if="embedCode" class="embed-element" v-html="embedCode" />
        <!--eslint-enable-->
        <CodeIcon
          v-else
          color="#697586"
          width="86"
          height="86"
          class="placeholder-image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ElementControls from "@/components/form_fields/shared/element-controls.vue";
import commonStyles from "@/components/form_fields/shared/commonStyles";
import SmartText from "@/components/form_fields/shared/smart-text.vue";
import sharedActions from "@/components/form_fields/shared/sharedActions";
import CodeIcon from "@/components/icons/code.vue";

export default {
  name: "FormEmbed",
  components: {
    ElementControls,
    SmartText,
    CodeIcon,
  },
  mixins: [commonStyles, sharedActions],
  props: {
    item: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["delete", "page-break", "duplicate", "hide"],
  computed: {
    code() {
      return this.item.code;
    },
    embedCode() {
      return this.parseEmbedCode(this.code);
    },
    embedHeight() {
      return this.itemStyling.height || "fit-content";
    },
    embedWidth() {
      return "100%";
    },
  },
  methods: {
    parseEmbedCode(code) {
      code = this.handleScriptTag(code);
      code = this.handleStyleTag(code);
      return code;
    },
    handleScriptTag(code) {
      const scriptMatchPattern =
        /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      let matches = code.match(scriptMatchPattern);
      code = code.replace(scriptMatchPattern, "");

      if (matches) {
        matches.forEach((script) => {
          const divFragment = document
            .createRange()
            .createContextualFragment(script);
          document.body.prepend(divFragment);
        });
      }

      return code;
    },
    handleStyleTag(code) {
      // update height
      const heightMatchPattern = /height="(.*?)"/;
      code = code.replace(heightMatchPattern, `height="${this.embedHeight}"`);

      // update width
      const widthMatchPattern = /width="(.*?)"/;
      code = code.replace(widthMatchPattern, `width="${this.embedWidth}"`);

      return code;
    },
  },
};
</script>

<style>
.embed-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.embed-element {
  width: 100%;
}

.embed-wrapper:has(svg.placeholder-image) {
  background-color: #f2f4f7;
  height: 250px;
  border-radius: 4px;
}
</style>
